<template>
  <div
    class="row row-inside separator-int"
    v-if="facture"
  >
    <div class="flex md1">
      <p>
        <b>{{
          moment(facture.date_facturation, "YYYY-MM-DD").format("YYYY") +
          "/" +
          moment(facture.date_facturation, "YYYY-MM-DD").format("MM") +
          "-" +
          facture.idfacture_publication
        }}</b>
      </p>
      <b class="smalltext">Devis {{ facture.nb_devis }}</b>
      <div class="flex md12 ma-0 pa-0">
        <va-button
          class="button-comments"
          small
          outline
          :color="facture.nbcomments ? 'success' : 'info'"
          @click="showComments = !showComments"
        >Commentaires</va-button>
      </div>
    </div>
    <div class="flex md2">
      {{ facture.nom_partenaire }}
    </div>
    <div class="flex md1 centered">
      {{ moment(facture.date_facturation).format("DD/MM/YYYY") }}
    </div>
    <div class="flex md1 centered">
      <p>{{ facture.montant_ttc }} €</p>
      <p v-if="facture.montant_ttc !== facture.montant_ht">
        (HT: {{ facture.montant_ht }} €)
      </p>
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth"
        :color="facture.date_paiement ? 'success' : 'info'"
        @click="openPaiementEditor"
      >{{
          facture.date_paiement
            ? "Payé le " + moment(facture.date_paiement).format("DD/MM/YYYY")
            : "Non payé"
        }}</va-button>
    </div>

    <div class="flex md1">
      <va-button
        class="fullwidth"
        color="success"
        @click="openFactureEditor"
      >Editer</va-button>
    </div>

    <div class="flex md1 col-pos">
      <va-button
        class="fullwidth"
        :color="facture.date_envoi ? 'success' : 'info'"
        @click="dispDevis()"
      >Devis
        {{
          facture.date_envoi
            ? moment(facture.date_envoi, "YYYY-MM-DD").format("DD/MM/YYYY")
            : ""
        }}</va-button>
    </div>

    <div class="flex md1 centered">
      <b>{{ moment(facture.mois+'-'+facture.annee, 'MM-YYYY').format('MMMM YYYY') }}</b>
    </div>
    <div class="flex md1 centered"></div>
    <div class="flex md2">
      {{ facture.uname_attribution }}
    </div>
    <div
      class="flex md12 mb-3 mt-0 pt-0"
      v-if="showComments"
    >
      <devis-comments-list
        class="relance-container-list"
        :iddevis_publications="facture.iddevis_publication"
        setheight="15"
      />
    </div>
    <devis-visualisation
      :iddevis="facture.iddevis_publication"
      v-model="showVisDevis"
      v-on:modify="openEdit"
    />
    <devis-modification
      :iddevis="facture.iddevis_publication"
      v-model="showEditDevis"
      v-on:modified="reloadList"
    />
    <upload-devis
      :iddevis="facture.iddevis_publication"
      v-model="showUpload"
      :entrepriseName="facture.nom"
    />

    <va-modal
      class="modal"
      v-model="showFacture"
      v-on:cancel="showFacture = false"
      :hideDefaultActions="true"
      disabled
      title="Edition facture"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <va-button
            class="fullwidth"
            color="info"
            @click="getFacture(facture.idfacture)"
            :disabled="!facture.idfacture"
            v-show="facture.idfacture"
          >Télécharger la facture</va-button>
        </div>
        <div class="flex md6">
          <va-button
            class="fullwidth"
            color="info"
            @click="editFacture(facture.idfacture)"
          >{{
              facture.idfacture ? "Réédition de la" : "Editer la"
            }}
            facture</va-button>
        </div>

        <div class="flex md6">
          <va-date-picker
            :config="{ dateFormat: 'd-m-Y' }"
            v-model="dateFacture"
          />
        </div>
        <div class="flex md12">
          <va-button
            class="fullwidth"
            color="danger"
            @click="annulerFacture"
            :disabled="!facture.idfacture"
            v-show="facture.idfacture"
          >Annuler la facture</va-button>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      v-model="showDeleteConfirm"
      okText="Confirmer"
      cancelText="Annuler"
      v-on:cancel="showDeleteConfirm = false"
      v-on:ok="deleteFacture"
      title="Annulation facture"
    >
      Confirmer l'annulation de la facture?
    </va-modal>
    <va-modal
      class="modal"
      v-model="showWaiting"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
    >
      <va-progress-circle
        indeterminate
        color="info"
      />
    </va-modal>
    <paiement-modal
      v-model="showPaiement"
      :idfacture="facture.idfacture"
      @update="resetComponent"
    />
  </div>
</template>

<script>
import axios from "axios";
import DevisVisualisation from "./devisVisualisation";
import DevisModification from "./devisModification";
import moment from "moment";
import DevisCommentsList from "./devisCommentsList";
import UploadDevis from "./uploadDevis";
import PaiementModal from "./paiementModal.vue";

export default {
  name: "facture-list-line",
  props: ["facture"],
  components: {
    DevisVisualisation,
    DevisModification,
    DevisCommentsList,
    UploadDevis,
    PaiementModal,
  },

  data() {
    return {
      moment: moment,
      showUpload: false,
      showComments: false,
      annonce: null,
      paid: false,
      showVisDevis: false,
      showEditDevis: false,
      showFacture: false,
      dateFacture: moment().format("DD-MM-YYYY"),
      showDeleteConfirm: false,
      showWaiting: false,
      showFacture: false,
      showPaiement: false,
    };
  },

  created() { },
  mounted() { },
  computed: {
    validationTexte() {
      if (this.facture.date_validation) {
        return (
          "Validé le " +
          moment(this.facture.date_validation, "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          )
        );
      } else {
        return "En attente";
      }
    },
  },
  methods: {
    montantProp(annonce) {
      let montant = annonce.montant;
      let remise = (annonce.montant * annonce.remise) / 100;
      let remise_fixe = annonce.remise_fixe
        ? parseFloat(annonce.remise_fixe)
        : 0;
      return montant - remise - remise_fixe;
    },
    annulerFacture() {
      this.showDeleteConfirm = true;
    },
    resetComponent() {
      this.$emit("reset");
    },
    async deleteFacture() {
      try {
        this.showWaiting = true;
        let params = { idfacture: this.facture.idfacture };
        await axios.delete("/api/publications-web/facture", { params: params });
        this.launchEpicmaxToast("Facture supprimé");
        this.showFacture = false;
        this.showDeleteConfirm = false;
        this.showWaiting = false;
        this.resetComponent();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la suppression");
        this.showWaiting = false;
      }
    },
    async getFacture(idfacture) {
      try {
        this.showWaiting = true;
        let resTmp = await axios.get("/api/publications-web/facture", {
          params: { idfacture: idfacture },
        });
        // open facture
        let url = resTmp.data.pdfurl;
        let facture_id = resTmp.data.facture_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Facture_" + facture_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Facture éditée");
        this.showFacture = false;
        this.showWaiting = false;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération de la facture");
        this.showWaiting = false;
      }
    },
    async editFacture() {
      try {
        this.showWaiting = true;
        let params = {
          idannonce: this.facture.idannonce,
          dateFacture: moment(this.dateFacture, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
        };

        let resTmp = await axios.post("/api/publications-web/facture", params);
        this.resetComponent();
        // open facture
        let url = resTmp.data.pdfurl;
        let facture_id = resTmp.data.facture_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Facture_" + facture_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Facture éditée");
        this.showFacture = false;
        this.showWaiting = false;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'édition de la facture");
        this.showWaiting = false;
      }
    },
    openPaiementEditor() {
      this.showPaiement = false;
      this.showPaiement = true;
    },
    openFactureEditor() {
      this.showFacture = false;
      this.showFacture = true;
    },
    reloadList() {
      this.resetComponent();
    },
    openEdit(iddevis) {
      this.showVisDevis = false;
      this.showEditDevis = true;
    },
    dispDevis() {
      this.showEditDevis = false;
      if (!this.showVisDevis) {
        this.showVisDevis = true;
      } else {
        this.showVisDevis = false;
        this.showVisDevis = true;
      }
    },
    async changeAttribution() { },
    attributionMessage(facture) {
      if (!facture.idutilisateur_attribution) {
        return "Non attribué";
      }

      return facture.nom_complet;
    },
    attributionColor(facture) {
      if (!facture.idutilisateur_attribution) {
        return "info";
      }
      if (
        facture.idutilisateur_attribution ===
        this.$store.getters.user.idutilisateurs
      ) {
        return "success";
      }
      return "danger";
    },

    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.smalltext {
  font-size: 0.8em;
}
.fullwidth {
  width: 95%;
  font-size: 0.8em;
}

.kitmedia {
  font-size: 0.8em;
}

.col-pos {
  text-align: center;
}
.centered {
  padding-left: 15%;
}

.separator-int {
  border-bottom: 1px solid #ccc;
}

.button-comments {
  margin: 5px 0;
  padding: 1px 5px;
}

.centered {
  text-align: center;
}
</style>
